import { useMutation } from 'react-query';
import { AxiosInstance } from '../axios.config';
import { api } from '../constants';
import { IResetPassword } from '../auth/types';

const initSendResetPasswordEmail = async (email: string): Promise<{ message: string }> => {
  const response = await AxiosInstance.post<{ message: string }>(api.auth.sendResetPasswordEmail, {
    email,
    role: 'vendor',
  });
  return response.data;
};

const useSendResetPasswordEmailMutation = () => {
  return useMutation({
    mutationFn: (email: string) => initSendResetPasswordEmail(email),
    onError: (error) => {
      console.error('Error sending reset password email:', error);
    },
  });
};

const initResetPassword = async (
  data: IResetPassword,
  uid: string,
  token: string,
): Promise<{ message: string }> => {
  const urlWithParams = `${api.auth.resetPassword}?uid=${encodeURIComponent(
    uid,
  )}&token=${encodeURIComponent(token)}&role=vendor`;
  const response = await AxiosInstance.patch<{ message: string }>(urlWithParams, data);
  return response.data;
};

const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: (data: {
      password: string;
      confirm_password: string;
      uid: string;
      token: string;
    }) =>
      initResetPassword(
        { password: data.password, confirm_password: data.confirm_password },
        data.uid,
        data.token,
      ),
    onError: (error) => {
      console.error('Error resetting password:', error);
    },
  });
};

export { useSendResetPasswordEmailMutation, useResetPasswordMutation };
